import { render, staticRenderFns } from "./fundamentacaoApostila.vue?vue&type=template&id=6b3f078e&"
import script from "./fundamentacaoApostila.vue?vue&type=script&lang=js&"
export * from "./fundamentacaoApostila.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports